<div class="flex flex-col fill">
  <mic-header class="cardealer-header">
    <div class="flex flex-row items-center justify-between">
      <div class="flex flex-row flex-none items-center">
        <mic-sidebar-toggler [alwaysDisplay]="true" [open]="false" id="main-sidebar-toggler" type="left"></mic-sidebar-toggler>
        <a routerLink="/">
          <mic-logo type="commercial"></mic-logo>
        </a>
      </div>
      <div class="flex flex-row flex-1 sm-hidden h-full">
        <!-- <img src="/assets/images/logo-cardealer-full.png" height="12px" routerLink="/" style="cursor: pointer" /> -->
        <a routerLink="/" class="cardealer-title"><span><b>CAR</b>DEALER</span></a>
      </div>

      <div class="flex flex-row flex-none gap-3 items-center pr-4">
        <!-- <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="setTheme()">
        <mat-icon [fontIcon]="darkMode ? 'light_mode' : 'bedtime'"></mat-icon> {{ darkMode ? 'Tema Claro' : 'Tema Escuro' }}
      </button> -->
      <!--
      <button mat-flat-button color="primary" class="mic-btn-icon-left" [matMenuTriggerFor]="languageMenu">
        <mat-icon>translate</mat-icon> Português
      </button>
      <mat-menu #languageMenu="matMenu">
        <button mat-menu-item><img class="h-3 mr-2" src="assets/images/flags/br.svg" /> Português</button>
        <button mat-menu-item><img class="h-3 mr-2" src="assets/images/flags/fr.svg" /> Francês</button>
        <button mat-menu-item><img class="h-3 mr-2" src="assets/images/flags/us.svg" /> Inglês</button>
        <button mat-menu-item><img class="h-3 mr-2" src="assets/images/flags/es.svg" /> Espanhol</button>
      </mat-menu>
      -->
      <button mat-flat-button color="primary" class="mic-btn-icon-left"><mat-icon>account_circle</mat-icon> {{ userData?.name }}</button>
      <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="logout()"><mat-icon>logout</mat-icon> Sair</button>
    </div>
  </div>
</mic-header>
<mic-sidebar-container leftToggler="main-sidebar-toggler">
  <mic-sidebar position="start" mode="large" >
    <mic-sidebar-item link="/" icon="home" label="Início"></mic-sidebar-item>
    @if (hasPermissions(['DASHBOARD'])) {
      <mic-sidebar-item link="/dashboard" icon="insights" label="Dashboard"></mic-sidebar-item>
    }
    @if (hasPermissions(['REPORT'])) {
      <mic-sidebar-item link="/reports" icon="leaderboard" label="Relatórios"></mic-sidebar-item>
    }
    @if (hasPermissions(['LIST_DEALERSHIP'])) {
      <mic-sidebar-item link="/dealerships" icon="business" label="Concessionárias (CCS)"></mic-sidebar-item>
    }
    @if (hasPermissions(['LIST_DISTRIBUTOR'])) {
      <mic-sidebar-item link="/distributors" active="/distributors" icon="storefront" label="Dist. Exclusivos (DES)"></mic-sidebar-item>
    }
    @if (hasPermissions(['LIST_AUTOMAKER'])) {
      <mic-sidebar-item link="/automakers" icon="precision_manufacturing" label="Montadoras (OES)"></mic-sidebar-item>
    }
    @if (hasPermissions(['LIST_DISTRIBUTOR_STOCK'])) {
      <mic-sidebar-item link="/des-stock" active="/distributors/stock" icon="inventory" label="Estoque (DES)"></mic-sidebar-item>
    }
    @if (hasPermissions(['LIST_MICHELIN_STOCK'])) {
      <mic-sidebar-item link="/michelin-stock" icon="all_inbox" label="Estoque Michelin"></mic-sidebar-item>
    }
    @if (hasPermissions(['LIST_ORDER'])) {
      <mic-sidebar-item link="/orders" icon="shopping_cart" label="Pedidos"></mic-sidebar-item>
    }
    @if (isMichelinUser && hasPermissions(['LIST_USER'])) {
      <mic-sidebar-item link="/users" icon="groups" label="Usuários"></mic-sidebar-item>
    }
    @if (isMichelinUser && hasPermissions(['LIST_USER_PROFILE'])) {
      <mic-sidebar-item link="/user-profiles" icon="assignment_ind" label="Grupos de Usuários"></mic-sidebar-item>
    }
    @if (isMichelinUser) {
      <mic-sidebar-item link="/city-attributes" icon="south_america" label="Gestão de Territórios"></mic-sidebar-item>
    }
  </mic-sidebar>
  <mic-main-content main>
    <div class="flex flex-col fill justify-between" content>
        <div class="sidebar-container-content" [ngClass]="{
          'no-padding': appRouter.url === '/' || appRouter.url === ''
        }">
        <router-outlet></router-outlet>
      </div>
      <mic-footer color="blue">
        <div class="xs-self-center"></div>
        <div class="xs-self-center">Copyright Michelin &copy; {{ year }}</div>
        <div class="version xs-self-center">Version {{ version }}</div>
      </mic-footer>
    </div>
  </mic-main-content>
</mic-sidebar-container>
<mic-alert-center [hideDelay]="8"></mic-alert-center>
</div>
